/**
 *
 * CompanyActivity
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class CompanyActivity extends React.Component {
  render() {
    return (
      <div className="CompanyActivityComponent">
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
        <div>Michelle creo la empresa Terceriza. 2 h</div>
      </div>
    )
  }
}

CompanyActivity.propTypes = {}

export default CompanyActivity
